export { default as NModal, modalProps } from './src/Modal';
